/* Comparison UI. Data: assets/rb-product-vergleich-data.js (JSON until the source is decided). */
(() => {
  const ICONS = {"activity":"<path d=\"M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2\" />","badge-check":"<path d=\"M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z\" /> <path d=\"m9 12 2 2 4-4\" />","battery-charging":"<path d=\"M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2\" /> <path d=\"M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1\" /> <path d=\"m11 7-3 5h4l-3 5\" /> <line x1=\"22\" x2=\"22\" y1=\"11\" y2=\"13\" />","briefcase":"<path d=\"M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16\" /> <rect width=\"20\" height=\"14\" x=\"2\" y=\"6\" rx=\"2\" />","calendar":"<path d=\"M8 2v4\" /> <path d=\"M16 2v4\" /> <rect width=\"18\" height=\"18\" x=\"3\" y=\"4\" rx=\"2\" /> <path d=\"M3 10h18\" />","dumbbell":"<path d=\"M14.4 14.4 9.6 9.6\" /> <path d=\"M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z\" /> <path d=\"m21.5 21.5-1.4-1.4\" /> <path d=\"M3.9 3.9 2.5 2.5\" /> <path d=\"M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z\" />","euro":"<path d=\"M4 10h12\" /> <path d=\"M4 14h9\" /> <path d=\"M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2\" />","flame":"<path d=\"M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z\" />","gauge":"<path d=\"m12 14 4-4\" /> <path d=\"M3.34 19a10 10 0 1 1 17.32 0\" />","glasses":"<circle cx=\"6\" cy=\"15\" r=\"4\" /> <circle cx=\"18\" cy=\"15\" r=\"4\" /> <path d=\"M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2\" /> <path d=\"M2.5 13 5 7c.7-1.3 1.4-2 3-2\" /> <path d=\"M21.5 13 19 7c-.7-1.3-1.5-2-3-2\" />","layers":"<path d=\"m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z\" /> <path d=\"m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65\" /> <path d=\"m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65\" />","list":"<path d=\"M3 12h.01\" /> <path d=\"M3 18h.01\" /> <path d=\"M3 6h.01\" /> <path d=\"M8 12h13\" /> <path d=\"M8 18h13\" /> <path d=\"M8 6h13\" />","move":"<path d=\"M12 2v20\" /> <path d=\"m15 19-3 3-3-3\" /> <path d=\"m19 9 3 3-3 3\" /> <path d=\"M2 12h20\" /> <path d=\"m5 9-3 3 3 3\" /> <path d=\"m9 5 3-3 3 3\" />","palette":"<circle cx=\"13.5\" cy=\"6.5\" r=\".5\" fill=\"currentColor\" /> <circle cx=\"17.5\" cy=\"10.5\" r=\".5\" fill=\"currentColor\" /> <circle cx=\"8.5\" cy=\"7.5\" r=\".5\" fill=\"currentColor\" /> <circle cx=\"6.5\" cy=\"12.5\" r=\".5\" fill=\"currentColor\" /> <path d=\"M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z\" />","phone":"<path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\" />","shield-check":"<path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\" /> <path d=\"m9 12 2 2 4-4\" />","sliders-horizontal":"<line x1=\"21\" x2=\"14\" y1=\"4\" y2=\"4\" /> <line x1=\"10\" x2=\"3\" y1=\"4\" y2=\"4\" /> <line x1=\"21\" x2=\"12\" y1=\"12\" y2=\"12\" /> <line x1=\"8\" x2=\"3\" y1=\"12\" y2=\"12\" /> <line x1=\"21\" x2=\"16\" y1=\"20\" y2=\"20\" /> <line x1=\"12\" x2=\"3\" y1=\"20\" y2=\"20\" /> <line x1=\"14\" x2=\"14\" y1=\"2\" y2=\"6\" /> <line x1=\"8\" x2=\"8\" y1=\"10\" y2=\"14\" /> <line x1=\"16\" x2=\"16\" y1=\"18\" y2=\"22\" />","smartphone":"<rect width=\"14\" height=\"20\" x=\"5\" y=\"2\" rx=\"2\" ry=\"2\" /> <path d=\"M12 18h.01\" />","snowflake":"<line x1=\"2\" x2=\"22\" y1=\"12\" y2=\"12\" /> <line x1=\"12\" x2=\"12\" y1=\"2\" y2=\"22\" /> <path d=\"m20 16-4-4 4-4\" /> <path d=\"m4 8 4 4-4 4\" /> <path d=\"m16 4-4 4-4-4\" /> <path d=\"m8 20 4-4 4 4\" />","sparkles":"<path d=\"M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z\" /> <path d=\"M20 3v4\" /> <path d=\"M22 5h-4\" /> <path d=\"M4 17v2\" /> <path d=\"M5 18H3\" />","sun":"<circle cx=\"12\" cy=\"12\" r=\"4\" /> <path d=\"M12 2v2\" /> <path d=\"M12 20v2\" /> <path d=\"m4.93 4.93 1.41 1.41\" /> <path d=\"m17.66 17.66 1.41 1.41\" /> <path d=\"M2 12h2\" /> <path d=\"M20 12h2\" /> <path d=\"m6.34 17.66-1.41 1.41\" /> <path d=\"m19.07 4.93-1.41 1.41\" />","user":"<path d=\"M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2\" /> <circle cx=\"12\" cy=\"7\" r=\"4\" />"};

  const CHECK = '<svg class="rb-product-vergleich__mark-icon" viewBox="0 0 24 24" width="24" height="24" aria-label="ja"><circle cx="12" cy="12" r="12" fill="#111111"></circle><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#FFFFFF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const CROSS = '<svg class="rb-product-vergleich__mark-icon" viewBox="0 0 24 24" width="24" height="24" aria-label="nein"><circle cx="12" cy="12" r="12" fill="#E4E4E4"></circle><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" fill="none" stroke="#8A8A8A" stroke-width="2" stroke-linecap="round"></path></svg>';
  const CHEVRON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>';
  const ARROW = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
  const SCROLL_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg>';

  const SEGMENTS = {
    'golite-boots': 'Mobil',
    'golite-pants': 'Mobil',
    goxmini: 'Mobil',
    goxlite: 'Mobil',
    gox: 'Mobil',
    onelite: 'Stationär',
    one: 'Stationär',
    onepro: 'Stationär'
  };

  const FOCUS_OPTIONS = [
    ['', 'Alle'],
    ['pl', 'Preis/Leistungsvergleich'],
    ['feature', 'Feature-Vergleich'],
    ['kauf', 'Zusätzliche Kaufoptionen'],
    ['after', 'After-Sales-Optionen']
  ];

  const AS_OF = '05.10.2026';
  const RENT_FALLBACK = 'https://reboots.com/collections/rent';

  function esc(value) {
    return String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function rowKey(label) {
    return String(label).replace(/\s*\[.*\]\s*$/, '').trim();
  }

  const ROW_GROUPS = [
    {
      title: 'Preis',
      test: [
        /^UVP$/,
        /^Preis pro Programm$/,
        /^Preis pro Luftkammer$/,
        /^Preis pro Manschette$/,
        /^Preis pro Wellenlänge$/,
        /^Bundle-Staffelrabatt$/,
        /^Mieten statt kaufen$/,
        /^Saisonale Nutzungsoption$/,
        /^Garantieverlängerung/
      ]
    },
    {
      title: 'Gerät',
      test: [
        /^Zertifiziertes Medizinprodukt$/,
        /^Gerätetyp$/,
        /^Wireless$/,
        /^Pants bis zum unteren Rücken$/,
        /^Ganzes Bein/,
        /^Kälte und Wärme$/,
        /^Kälte, Wärme/,
        /^Kühlung ohne Eis$/,
        /^Wärmefunktion$/,
        /^Temperaturbereich$/,
        /^Maximaler Druck$/,
        /^Intensitätsstufen$/,
        /^Luftkammern pro Bein$/,
        /^Verfügbare Manschettentypen$/,
        /^Y-Connector/,
        /^Automatische Drainage/,
        /^Manschetten inklusive$/,
        /^Akkulaufzeit/,
        /^Fassungsvermögen$/,
        /^Thermo-Isolierung$/,
        /^Wellenlängen$/,
        /^Blau-/,
        /^Blaulichtfreier/,
        /^Mattenfläche$/,
        /^Für Training auf der Matte/,
        /^Rutschfeste Rückseite$/
      ]
    },
    {
      title: 'Programme',
      test: [
        /^Massageprogramme$/,
        /^Massagemodi$/,
        /^Eigene Programme$/,
        /^Kammersteuerung$/,
        /^Programm-Designer$/,
        /^Upside-Down/,
        /^HOLD- und Intervall/,
        /^Vorprogrammierte Modi$/,
        /^Eigene Routine/
      ]
    },
    {
      title: 'App',
      test: [
        /^Steuerung per App$/,
        /^Recovery Balance Score$/,
        /^Individuelle Programmempfehlungen/
      ]
    }
  ];

  const HIDDEN_ROW = /^(Ready to go|Custom Design|Second Hand)/;

  function rowPlace(label) {
    const key = rowKey(label);
    if (/^Ready to go/.test(key)) return 900;
    if (/^Custom Design/.test(key)) return 901;
    if (/^Second Hand/.test(key)) return 902;
    if (/^Telefonische Beratung/.test(key)) return 800;
    for (let groupIndex = 0; groupIndex < ROW_GROUPS.length; groupIndex += 1) {
      const patternIndex = ROW_GROUPS[groupIndex].test.findIndex((pattern) => pattern.test(key));
      if (patternIndex >= 0) return (groupIndex + 1) * 100 + patternIndex;
    }
    return 850;
  }

  function rowGroupTitle(label) {
    if (rowPlace(label) >= 800) return 'Weitere Benefits';
    const key = rowKey(label);
    const group = ROW_GROUPS.find((entry) => entry.test.some((pattern) => pattern.test(key)));
    return group ? group.title : '';
  }

  function hostLabel(url) {
    try {
      return new URL(url).hostname.replace(/^www\./, '');
    } catch (error) {
      return url || '';
    }
  }

  function iconSvg(name) {
    const inner = ICONS[name];
    if (!inner) return '';
    return `<svg class="rb-product-vergleich__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;
  }

  function winner(vals, label) {
    if (/^Akkulaufzeit/i.test(label)) return -1;
    const lower = /^(UVP|Preis|Mieten|Saisonale|Gewicht)/i.test(label);
    const scored = vals.map((value) => {
      const main = String(value == null ? '–' : value).replace(/\s*\[.*\]\s*$/, '').trim();
      if (main === '✓') return { t: 'b', v: 1 };
      if (main === '✗') return { t: 'b', v: 0 };
      if (/^(k\. ?A\.|n\. ?a\.|–|-|)$/i.test(main)) return { t: 'x' };
      const number = main.match(/\d[\d.]*(?:,\d+)?/);
      if (number) return { t: 'n', v: parseFloat(number[0].replace(/\./g, '').replace(',', '.')) };
      return { t: 's', v: main };
    });
    const types = {};
    scored.forEach((entry) => {
      if (entry.t !== 'x') types[entry.t] = 1;
    });
    const keys = Object.keys(types);
    if (keys.length !== 1 || keys[0] === 's') return -1;
    let best = null;
    let index = -1;
    let tie = false;
    scored.forEach((entry, entryIndex) => {
      if (entry.t === 'x') return;
      const better = best === null || (keys[0] === 'n' && lower ? entry.v < best : entry.v > best);
      if (better) {
        best = entry.v;
        index = entryIndex;
        tie = false;
      } else if (entry.v === best) {
        tie = true;
      }
    });
    if (tie || index < 0) return -1;
    if (keys[0] === 'b' && best !== 1) return -1;
    return index;
  }

  function parseValue(value, pill, bold, outline) {
    const match = String(value).match(/^(.*?)\s*(?:\[(.*)\])?\s*$/);
    const main = (match[1] || '').trim();
    const isCheck = main === '✓';
    const isCross = main === '✗';
    return {
      main,
      sub: match[2] || '',
      hasSub: !!match[2],
      isCheck,
      isCross,
      isText: !isCheck && !isCross,
      pill,
      outline,
      bold,
      strong: pill || outline
    };
  }

  function valueHtml(parsed) {
    const classes = ['rb-product-vergleich__value'];
    if (parsed.pill) classes.push('is-pill');
    if (parsed.outline) classes.push('is-outline');
    if (parsed.isCheck) classes.push('is-check');
    if (parsed.strong) classes.push('is-strong');
    else if (parsed.bold) classes.push('is-bold');
    let inner = `<span>${esc(parsed.main)}</span>`;
    if (parsed.isCheck) inner = CHECK;
    else if (parsed.isCross) inner = CROSS;
    const sub = parsed.hasSub ? `<span class="rb-product-vergleich__sub">${esc(parsed.sub)}</span>` : '';
    return `<span class="${classes.join(' ')}">${inner}</span>${sub}`;
  }

  class ProductVergleich {
    constructor(root) {
      const data = window.RbProductVergleichData;
      this.root = root;
      this.groups = data.groups;
      this.products = data.products;
      this.footnotes = data.footnotes;
      this.alts = data.alts;
      this.showName = true;
      this.hideCompetitors = root.hasAttribute('data-hide-competitors');
      this.state = {
        idx: 0,
        shown: 0,
        vs: '',
        vs3: '',
        focus: '',
        expanded: false,
        alt: {},
        narrow: root.getBoundingClientRect().width > 0 && root.getBoundingClientRect().width < 720,
        canRight: false
      };
      this.timer = 0;
      this.pendingFocus = '';
      this.bind();
      this.applyStartModel();
      this.syncNarrow();
      this.renderChrome();
      this.renderStage();
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(() => this.onResize());
        this.observer.observe(root);
      }
      window.addEventListener('resize', () => this.onResize());
      window.addEventListener('scroll', () => this.checkScroll(), { passive: true });
    }

    bind() {
      this.root.addEventListener('click', (event) => this.onClick(event));
      this.root.addEventListener('change', (event) => this.onChange(event));
      this.root.addEventListener('keydown', (event) => this.onKeydown(event));
      this.root.addEventListener('scroll', (event) => {
        if (event.target.matches('[data-scroller]')) this.checkScroll();
      }, true);
    }

    applyStartModel() {
      let key = this.root.dataset.defaultModel || 'golite-boots';
      try {
        const param = new URLSearchParams(location.search).get('modell');
        if (param) key = param.toLowerCase();
      } catch (error) {
        /* keep default */
      }
      const index = this.products.findIndex((product) => product.id === key);
      if (index > 0) {
        this.state.idx = index;
        this.state.shown = index;
      }
    }

    syncNarrow() {
      this.root.classList.toggle('is-narrow', this.state.narrow);
    }

    onResize() {
      const narrow = this.root.getBoundingClientRect().width < 720;
      if (narrow === this.state.narrow) {
        this.checkScroll();
        return;
      }
      this.state.narrow = narrow;
      this.syncNarrow();
      this.checkScroll();
    }

    groupOf(index) {
      const id = this.products[index].id;
      return Math.max(0, this.groups.findIndex((group) => group.products.includes(id)));
    }

    groupIndexes(groupIndex) {
      return this.groups[groupIndex].products
        .map((id) => this.products.findIndex((product) => product.id === id))
        .filter((index) => index >= 0);
    }

    sortRows(rows) {
      return rows.slice().sort((a, b) => {
        const delta = rowPlace(a[0]) - rowPlace(b[0]);
        if (delta !== 0) return delta;
        return rowKey(a[0]).localeCompare(rowKey(b[0]), 'de');
      });
    }

    altIndex(productId) {
      const chosen = (this.state.alt || {})[productId];
      if (chosen != null) return chosen;
      const alternatives = this.alts[productId] || [];
      const base = this.products.find((product) => product.id === productId);
      if (productId === 'onepro') {
        const isStationary = (value) => /^stationär/i.test(String(value || ''));
        const baseRow = base ? base.rows.find((row) => /^Gerätetyp/.test(row[0])) : null;
        if (baseRow && isStationary(baseRow[3])) return 0;
        const stationaryIndex = alternatives.findIndex((alternative) => alternative.vals && alternative.vals['Gerätetyp'] && isStationary(alternative.vals['Gerätetyp'][0]));
        if (stationaryIndex >= 0) return stationaryIndex + 1;
      }
      if (base && /Blackroll/i.test(base.comp)) return 0;
      const blackrollIndex = alternatives.findIndex((alternative) => /Blackroll/i.test(alternative.comp));
      return blackrollIndex >= 0 ? blackrollIndex + 1 : 0;
    }

    withAlt(product) {
      const index = this.altIndex(product.id);
      const alternative = index && this.alts[product.id] && this.alts[product.id][index - 1];
      if (!alternative) return product;
      const strip = (value) => String(value).replace(/\s*\[([^\]]*)\]\s*$/, (full, sub) => (
        /%|günstiger|mehr|doppelt|dreimal/i.test(sub) ? '' : full
      ));
      const rows = product.rows.map((row) => {
        const values = alternative.vals[rowKey(row[0])];
        return [
          row[0],
          row[1],
          values && values[2] != null ? values[2] : strip(row[2]),
          values ? values[0] : 'k. A.',
          values ? values[1] : '–'
        ].concat(row.slice(5));
      });
      return Object.assign({}, product, {
        comp: alternative.comp,
        category: alternative.category,
        compConfig: alternative.compConfig,
        priceBasis: alternative.priceBasis,
        sources: alternative.sources,
        rows
      });
    }

    focusOf(label, productId) {
      const text = rowKey(label);
      if (/^(Mieten statt kaufen|Saisonale Nutzungsoption|Second Hand|Bundles|Bundle-Staffelrabatt|Custom Design)/.test(text)) return 'kauf';
      if (/^(Garantieverlängerung|Telefonische Beratung)/.test(text)) return 'after';
      if (productId === 'golite-pants' && /^Pants bis zum unteren Rücken/.test(text)) return 'pl';
      if (/^(UVP|Preis pro|Luftkammern pro Bein|Maximaler Druck|Intensitätsstufen|Massageprogramme|Massagemodi|Kammersteuerung|Manschetten inklusive|Wellenlängen|Temperaturbereich|Fassungsvermögen|Mattenfläche|Verfügbare Manschettentypen)/.test(text)) return 'pl';
      return 'feature';
    }

    fade(apply, resetTableScroll) {
      const stage = this.root.querySelector('[data-stage]');
      if (stage) stage.classList.add('is-fading');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        apply();
        this.renderStage({ resetTableScroll: !!resetTableScroll });
        const next = this.root.querySelector('[data-stage]');
        if (next) next.classList.remove('is-fading');
        this.checkScroll();
      }, 180);
    }

    select(index, options = {}) {
      if (index === this.state.idx) return;
      const previousId = this.products[this.state.idx].id;
      const nextId = this.products[index].id;
      const sameGroup = this.groupOf(index) === this.groupOf(this.state.idx);
      let vs = sameGroup ? (this.state.vs || '') : '';
      let vs3 = sameGroup ? (this.state.vs3 || '') : '';
      if (vs === nextId) vs = previousId;
      if (vs3 === nextId) vs3 = previousId;
      if (!vs) vs3 = '';
      if (options.resetExpanded) this.state.expanded = false;
      this.state.idx = index;
      this.state.vs = vs;
      this.state.vs3 = vs3;
      this.renderChrome();
      this.fade(() => {
        this.state.shown = index;
      }, true);
      try {
        const url = new URL(location.href);
        url.searchParams.set('modell', nextId);
        history.replaceState(null, '', url);
      } catch (error) {
        /* ignore */
      }
    }

    onClick(event) {
      const group = event.target.closest('[data-group]');
      if (group && this.root.contains(group)) {
        const groupIndex = Number(group.dataset.group);
        if (groupIndex !== this.groupOf(this.state.idx)) {
          this.select(this.groupIndexes(groupIndex)[0]);
        }
        return;
      }
      const pill = event.target.closest('[data-pill]');
      if (pill && this.root.contains(pill)) {
        this.select(Number(pill.dataset.pill), { resetExpanded: true });
        return;
      }
      const focus = event.target.closest('[data-focus]');
      if (focus && this.root.contains(focus)) {
        const next = focus.dataset.focus;
        if (next === (this.state.focus || '')) return;
        this.fade(() => {
          this.state.focus = next;
          this.state.expanded = false;
        });
        return;
      }
      const alternative = event.target.closest('[data-alt]');
      if (alternative && this.root.contains(alternative)) {
        const productId = this.products[this.state.shown].id;
        this.state.alt = Object.assign({}, this.state.alt, { [productId]: Number(alternative.dataset.alt) });
        this.renderStage();
        return;
      }
      if (event.target.closest('[data-more]')) {
        this.state.expanded = !this.state.expanded;
        this.renderStage();
        return;
      }
      if (event.target.closest('[data-scroll]')) {
        const scroller = this.root.querySelector('[data-scroller]');
        if (scroller) scroller.scrollBy({ left: 220, behavior: 'smooth' });
      }
    }

    onChange(event) {
      if (event.target.matches('[data-vs]')) {
        const value = event.target.value;
        this.fade(() => {
          this.state.vs = value;
          this.state.vs3 = value && this.state.vs3 !== value ? this.state.vs3 : '';
          this.state.expanded = false;
        });
      }
      if (event.target.matches('[data-vs3]')) {
        const value = event.target.value;
        this.fade(() => {
          this.state.vs3 = value;
        });
      }
    }

    onKeydown(event) {
      const group = event.target.closest('[data-group]');
      if (group && this.root.contains(group)) {
        const count = this.groups.length;
        const current = Number(group.dataset.group);
        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % count;
        else if (event.key === 'ArrowLeft') next = (current - 1 + count) % count;
        if (next === null) return;
        event.preventDefault();
        this.pendingFocus = `[data-group="${next}"]`;
        this.select(this.groupIndexes(next)[0]);
        return;
      }
      const pill = event.target.closest('[data-pill]');
      if (!pill || !this.root.contains(pill)) return;
      const list = this.groupIndexes(this.groupOf(this.state.idx));
      const current = list.indexOf(Number(pill.dataset.pill));
      let next = null;
      if (event.key === 'ArrowRight') next = (current + 1) % list.length;
      else if (event.key === 'ArrowLeft') next = (current - 1 + list.length) % list.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = list.length - 1;
      if (next === null) return;
      event.preventDefault();
      this.pendingFocus = `[data-pill="${list[next]}"]`;
      this.select(list[next]);
    }

    renderChrome() {
      const groups = this.root.querySelector('[data-groups]');
      const pills = this.root.querySelector('[data-pills]');
      const pillScroll = pills ? pills.scrollLeft : 0;
      const activeGroup = this.groupOf(this.state.idx);
      groups.innerHTML = this.groups.map((group, index) => {
        const selected = index === activeGroup;
        return `<button type="button" class="rb-product-vergleich__group${selected ? ' is-selected' : ''}" data-group="${index}" role="tab" aria-selected="${selected ? 'true' : 'false'}" tabindex="${selected ? '0' : '-1'}">${esc(group.label)}</button>`;
      }).join('');
      const indexes = this.groupIndexes(activeGroup);
      const rows = [];
      indexes.forEach((productIndex) => {
        const product = this.products[productIndex];
        const segment = SEGMENTS[product.id] || '';
        const row = rows[rows.length - 1];
        if (!row || row.segment !== segment) rows.push({ segment, pills: [] });
        const selected = productIndex === this.state.idx;
        const logo = product.logo || ['', '', ''];
        rows[rows.length - 1].pills.push(`<button type="button" class="rb-product-vergleich__pill${selected ? ' is-selected' : ''}" data-pill="${productIndex}" role="tab" aria-selected="${selected ? 'true' : 'false'}" tabindex="${selected ? '0' : '-1'}" aria-label="${esc(product.name)}"><span class="rb-product-vergleich__logo"><span>${esc(logo[0])}</span>${logo[1] ? `<span class="rb-product-vergleich__logo-badge">${esc(logo[1])}</span>` : ''}${logo[2] ? `<span class="rb-product-vergleich__logo-suffix">${esc(logo[2])}</span>` : ''}</span></button>`);
      });
      pills.innerHTML = rows.map((row) => {
        const label = row.segment ? `<span class="rb-product-vergleich__segment">${esc(row.segment)}</span>` : '';
        return `<div class="rb-product-vergleich__segment-row">${label}${row.pills.join('')}</div>`;
      }).join('');
      pills.querySelectorAll('.rb-product-vergleich__segment-row').forEach((row) => {
        row.scrollLeft = pillScroll;
      });
      if (this.pendingFocus) {
        const target = this.root.querySelector(this.pendingFocus);
        this.pendingFocus = '';
        if (target) {
          target.focus();
          const row = target.closest('.rb-product-vergleich__segment-row');
          if (row) row.scrollLeft = Math.max(0, target.offsetLeft - 16);
        }
      }
    }

    view() {
      const hideCompetitors = this.hideCompetitors;
      if (hideCompetitors && this.state.vs3 === 'comp') this.state.vs3 = '';
      const shown = hideCompetitors ? this.products[this.state.shown] : this.withAlt(this.products[this.state.shown]);
      const groupList = this.groupIndexes(this.groupOf(this.state.shown));
      const vsIndex = this.state.vs ? this.products.findIndex((product) => product.id === this.state.vs) : -1;
      const isVs = vsIndex >= 0 && vsIndex !== this.state.shown;
      const compared = isVs ? this.products[vsIndex] : null;
      const clean = (value) => String(value).replace(/\s*\[([^\]]*)\]\s*$/, (full, sub) => (
        /%|günstiger|mehr|weniger|doppelt|dreimal|Vergleich/i.test(sub) ? '' : full
      ));
      const solo = hideCompetitors && !isVs;
      const thirdIndex = isVs && this.state.vs3 ? this.products.findIndex((product) => product.id === this.state.vs3) : -1;
      const thirdComp = !hideCompetitors && isVs && this.state.vs3 === 'comp';
      const thirdRb = thirdIndex >= 0 && thirdIndex !== this.state.shown && thirdIndex !== vsIndex;
      const hasThird = thirdComp || thirdRb;
      const thirdProduct = thirdRb ? this.products[thirdIndex] : null;
      let rows = shown.rows;
      if (isVs) {
        const list = [shown, compared].concat(thirdRb ? [thirdProduct] : []);
        const maps = list.map((product) => {
          const map = {};
          product.rows.forEach((row) => { map[rowKey(row[0])] = row; });
          return map;
        });
        const seen = {};
        rows = [];
        list.forEach((product) => product.rows.forEach((row) => {
          const key = rowKey(row[0]);
          if (seen[key]) return;
          seen[key] = true;
          const values = maps.map((map, mapIndex) => (
            map[key] ? ((thirdComp && mapIndex === 0) ? map[key][2] : clean(map[key][2])) : '–'
          ));
          const own = maps[0][key];
          const third = thirdComp ? (own ? own[3] : '–') : (values[2] || '–');
          const win = winner(thirdComp ? [values[0], values[1], third] : values, key);
          rows.push([row[0], row[1], values[0], values[1], '–', third, win]);
        }));
      }
      rows = this.sortRows(rows);
      const focusAvail = { '': true };
      rows.forEach((row) => { focusAvail[this.focusOf(row[0], shown.id)] = true; });
      const focus = focusAvail[this.state.focus || ''] ? (this.state.focus || '') : '';
      if ((this.state.focus || '') !== focus) this.state.focus = focus;
      if (focus) rows = rows.filter((row) => this.focusOf(row[0], shown.id) === focus);
      const cut = focus ? -1 : rows.findIndex((row) => HIDDEN_ROW.test(rowKey(row[0])));
      const canMore = cut >= 0 && cut < rows.length;
      const visible = canMore && !this.state.expanded ? rows.slice(0, cut) : rows;
      let lastGroup = '';
      const built = visible.map((row) => {
        const title = rowGroupTitle(row[0]);
        const groupTitle = title && title !== lastGroup ? title : '';
        if (title) lastGroup = title;
        const win = isVs ? row[6] : (hideCompetitors ? -1 : (row[4] === 'REBOOTS' ? 0 : -1));
        const label = rowKey(row[0]);
        const compWin = !hideCompetitors && !isVs && winner([row[2], row[3]], label) === 1;
        const rebootsValue = solo ? clean(row[2]) : row[2];
        return {
          groupTitle,
          label,
          labelSub: (String(row[0]).match(/\[(.*)\]/) || [])[1] || '',
          icon: row[1],
          reboots: parseValue(rebootsValue, win === 0, true, false),
          comp: parseValue(row[3], isVs && win === 1, isVs, compWin),
          third: parseValue(row[5] || '–', thirdRb && win === 2, thirdRb, thirdComp && win === 2)
        };
      });
      const alternatives = hideCompetitors ? [] : (this.alts[shown.id] || []);
      const names = alternatives.length ? [this.products.find((product) => product.id === shown.id).comp].concat(alternatives.map((item) => item.comp)) : [];
      const currentAlt = this.altIndex(shown.id);
      const source = (shown.sources || [])[0] || '';
      const canRent = (product) => product.rows.some((row) => row[0] === 'Mieten statt kaufen');
      return {
        shown,
        solo,
        isVs,
        compared,
        hasThird,
        thirdComp,
        thirdRb,
        thirdProduct,
        rows: built,
        canMore,
        expanded: !!this.state.expanded,
        focus,
        focusAvail,
        showName: this.showName,
        source,
        sourceLabel: hostLabel(source),
        compSwitch: alternatives.length ? names.map((name, index) => ({
          label: this.showName ? name : `Vergleichsprodukt ${index + 1}`,
          selected: index === currentAlt,
          index
        })) : [],
        vsOptions: [{ id: '', name: hideCompetitors ? 'Nur dieses Gerät' : 'Wettbewerb-Vergleichsprodukt' }].concat(
          groupList.filter((index) => index !== this.state.shown).map((index) => ({
            id: this.products[index].id,
            name: `Reboots ${this.products[index].name}`
          }))
        ),
        vs3Options: [{ id: '', name: 'Kein drittes Gerät' }].concat(
          hideCompetitors ? [] : [{ id: 'comp', name: `Wettbewerbs-Vergleichsprodukt zu Reboots ${shown.name}` }]
        ).concat(
          groupList.filter((index) => index !== this.state.shown && index !== vsIndex).map((index) => ({
            id: this.products[index].id,
            name: `Reboots ${this.products[index].name}`
          }))
        ),
        vsValue: isVs ? compared.id : '',
        vs3Value: thirdComp ? 'comp' : (thirdRb ? thirdProduct.id : ''),
        ctas: [shown].concat(isVs ? [compared] : (solo ? [] : [null])).concat(hasThird ? [thirdRb ? thirdProduct : null] : []).map((product) => (
          product ? {
            show: true,
            name: product.name,
            url: product.url,
            rentUrl: product.rentUrl || RENT_FALLBACK,
            canRent: canRent(product)
          } : { show: false }
        )),
        warranty: (shown.id.startsWith('relight') || shown.id === 'icetubpro' || shown.id === 'thermosleeves')
          ? '2 Jahre Garantie'
          : '2 Jahre Garantie + 1 Jahr Verlängerungsoption',
        canRent: rows.some((row) => row[0] === 'Mieten statt kaufen'),
        notes: hideCompetitors
          ? this.footnotes.filter((note) => !/Vergleichsprodukt|Genannte Marken|Händler/.test(note))
          : this.footnotes,
        tableLabel: solo
          ? shown.name
          : `Vergleich ${shown.name} mit ${isVs ? compared.name + (thirdRb ? ` und ${thirdProduct.name}` : (thirdComp ? ' und Wettbewerbs-Vergleichsprodukt' : '')) : 'Wettbewerb-Vergleichsprodukt'}`
      };
    }

    renderStage(options = {}) {
      const stage = this.root.querySelector('[data-stage]');
      const scroller = this.root.querySelector('[data-scroller]');
      const left = options.resetTableScroll ? 0 : (scroller ? scroller.scrollLeft : 0);
      stage.innerHTML = this.stageHtml(this.view());
      const next = this.root.querySelector('[data-scroller]');
      if (next) next.scrollLeft = left;
      this.checkScroll();
    }

    stageHtml(view) {
      const product = view.shown;
      const badge = (text) => text ? `<div class="rb-product-vergleich__badge">${esc(text)}</div>` : '';
      const image = (src, name) => src ? `<img class="rb-product-vergleich__photo" loading="lazy" src="${esc(src)}" alt="Reboots ${esc(name)}">` : '';
      const switchHtml = !view.solo && view.compSwitch.length ? `<div class="rb-product-vergleich__switch">${view.compSwitch.map((option) => `<button type="button" class="rb-product-vergleich__switch-btn${option.selected ? ' is-selected' : ''}" data-alt="${option.index}">${esc(option.label)}</button>`).join('')}</div>` : '';
      const nameHtml = !view.solo && view.showName ? `<div class="rb-product-vergleich__comp-name">${esc(product.comp)}</div>` : '';
      let compHead = '';
      if (!view.solo && view.isVs) {
        compHead = `<div class="rb-product-vergleich__head rb-product-vergleich__head--product">${image(view.compared.img, view.compared.name)}<div class="rb-product-vergleich__product-name">${esc(view.compared.name)}</div>${badge(view.compared.badge)}</div>`;
      } else if (!view.solo) {
        compHead = `<div class="rb-product-vergleich__head rb-product-vergleich__head--comp"><div class="rb-product-vergleich__comp-title">Wettbewerb-Vergleichsprodukt</div>${switchHtml}${nameHtml}<div class="rb-product-vergleich__muted">${esc(product.category)}</div><div class="rb-product-vergleich__meta">Ausstattung: ${esc(product.compConfig)}</div><div class="rb-product-vergleich__meta">Preisbasis: ${esc(product.priceBasis)}, Stand ${AS_OF}</div><a class="rb-product-vergleich__source" href="${esc(view.source)}" target="_blank" rel="noopener nofollow">Quelle: ${esc(view.sourceLabel)}</a></div>`;
      }
      let thirdHead = '';
      if (view.thirdComp) {
        thirdHead = `<div class="rb-product-vergleich__head rb-product-vergleich__head--comp"><div class="rb-product-vergleich__comp-title">Wettbewerbs-Vergleichsprodukt</div><div class="rb-product-vergleich__comp-kicker">zu Reboots ${esc(product.name)}</div>${switchHtml}${view.showName ? `<div class="rb-product-vergleich__comp-name">${esc(product.comp)}</div>` : ''}<div class="rb-product-vergleich__muted">${esc(product.category)}</div><div class="rb-product-vergleich__meta">Preisbasis: ${esc(product.priceBasis)}, Stand ${AS_OF}</div><a class="rb-product-vergleich__source" href="${esc(view.source)}" target="_blank" rel="noopener nofollow">Quelle: ${esc(view.sourceLabel)}</a></div>`;
      } else if (view.thirdRb) {
        thirdHead = `<div class="rb-product-vergleich__head rb-product-vergleich__head--product">${image(view.thirdProduct.img, view.thirdProduct.name)}<div class="rb-product-vergleich__product-name">${esc(view.thirdProduct.name)}</div>${badge(view.thirdProduct.badge)}</div>`;
      }
      const last = view.rows.length - 1;
      const rows = view.rows.map((row, index) => {
        const isLast = index === last ? ' is-last' : '';
        const third = view.hasThird ? `<div class="rb-product-vergleich__cell rb-product-vergleich__cell--third${isLast}" role="cell">${valueHtml(row.third)}</div>` : '';
        const comp = view.solo ? '' : `<div class="rb-product-vergleich__cell rb-product-vergleich__cell--comp${isLast}" role="cell">${valueHtml(row.comp)}</div>`;
        const heading = row.groupTitle ? `<div class="rb-product-vergleich__bucket">${esc(row.groupTitle)}</div>` : '';
        return `${heading}<div class="rb-product-vergleich__label${isLast}" role="rowheader">${iconSvg(row.icon)}<span class="rb-product-vergleich__label-text"><span>${esc(row.label)}</span>${row.labelSub ? `<span class="rb-product-vergleich__label-sub">${esc(row.labelSub)}</span>` : ''}</span></div><div class="rb-product-vergleich__cell rb-product-vergleich__cell--product${isLast}" role="cell">${valueHtml(row.reboots)}</div>${comp}${third}`;
      }).join('');
      const more = view.canMore ? `<div class="rb-product-vergleich__more-row"><button type="button" class="rb-product-vergleich__more" data-more><span>${view.expanded ? 'Weniger anzeigen' : 'Weitere Benefits für deine Recovery'}</span><span class="rb-product-vergleich__more-icon${view.expanded ? ' is-open' : ''}">${CHEVRON}</span></button></div>` : '';
      const ctas = `<div class="rb-product-vergleich__cta-spacer"></div>${view.ctas.map((cta) => `<div class="rb-product-vergleich__cta">${cta.show ? `<a class="rb-product-vergleich__buy" href="${esc(cta.url)}"><span>Zum ${esc(cta.name)}</span>${ARROW}</a>${cta.canRent ? `<a class="rb-product-vergleich__rent" href="${esc(cta.rentUrl)}"><span>${esc(cta.name)} mieten</span>${ARROW}</a>` : ''}` : ''}</div>`).join('')}`;
      const options = (list, selected) => list.map((option) => `<option value="${esc(option.id)}"${option.id === selected ? ' selected' : ''}>${esc(option.name)}</option>`).join('');
      const focus = FOCUS_OPTIONS.filter(([id]) => view.focusAvail[id]).map(([id, label]) => {
        const selected = view.focus === id;
        return `<button type="button" class="rb-product-vergleich__focus${selected ? ' is-selected' : ''}" data-focus="${esc(id)}" role="tab" aria-selected="${selected ? 'true' : 'false'}">${esc(label)}</button>`;
      }).join('');
      const thirdSelect = view.isVs ? `<label class="rb-product-vergleich__field"><span>Drittes Gerät (optional)</span><span class="rb-product-vergleich__select-wrap"><select data-vs3>${options(view.vs3Options, view.vs3Value)}</select>${CHEVRON}</span></label>` : '';
      return `
        ${product.claim ? `<p class="rb-product-vergleich__claim">${esc(product.claim)}</p>` : ''}
        <label class="rb-product-vergleich__field"><span>Vergleichen mit</span><span class="rb-product-vergleich__select-wrap"><select data-vs>${options(view.vsOptions, view.vsValue)}</select>${CHEVRON}</span></label>
        ${thirdSelect}
        <div class="rb-product-vergleich__focusbar" role="tablist" aria-label="Fokus wählen"><span class="rb-product-vergleich__focus-label">Fokus</span>${focus}</div>
        <div class="rb-product-vergleich__frame">
          <div class="rb-product-vergleich__scroller" data-scroller>
            <div class="rb-product-vergleich__table${view.solo ? ' is-solo' : ''}${view.isVs ? ' is-vs' : ''}${view.hasThird ? ' is-third' : ''}${view.thirdRb ? ' is-third-rb' : ''}" role="table" aria-label="${esc(view.tableLabel)}">
              <div class="rb-product-vergleich__corner" role="columnheader"></div>
              <div class="rb-product-vergleich__head rb-product-vergleich__head--product" role="columnheader">${image(product.img, product.name)}<div class="rb-product-vergleich__product-name">${esc(product.name)}</div>${badge(product.badge)}</div>
              ${compHead}
              ${thirdHead}
              ${rows}
              ${more}
              ${ctas}
            </div>
          </div>
          <button type="button" class="rb-product-vergleich__scroll" data-scroll aria-label="Tabelle weiter scrollen" hidden>${SCROLL_ICON}</button>
        </div>
        <div class="rb-product-vergleich__extras">
          <div class="rb-product-vergleich__extras-label">Bei Reboots außerdem mit dabei</div>
          <div class="rb-product-vergleich__chips">
            <span>Kostenloser Versand</span>
            <span>30 Tage Geld-zurück-Garantie</span>
            <span>${esc(view.warranty)}</span>
            ${view.canRent ? '<span>Mieten mit Kaufoption</span>' : ''}
          </div>
        </div>
        <ul class="rb-product-vergleich__notes">${view.notes.map((note) => `<li>${esc(note)}</li>`).join('')}</ul>
      `;
    }

    checkScroll() {
      const scroller = this.root.querySelector('[data-scroller]');
      const button = this.root.querySelector('[data-scroll]');
      const frame = this.root.querySelector('.rb-product-vergleich__frame');
      if (!scroller || !button || !frame) return;
      const scrollable = scroller.scrollWidth > scroller.clientWidth + 2;
      this.root.classList.toggle('is-scrollable', scrollable);
      const canRight = scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 26;
      this.state.canRight = canRight;
      button.hidden = !(this.state.narrow && canRight);
      if (button.hidden) {
        button.classList.remove('is-pinned');
        button.style.top = '';
        button.style.right = '';
        return;
      }
      const anchor = frame.querySelector('.rb-product-vergleich__bucket') || frame.querySelector('.rb-product-vergleich__label');
      const frameRect = frame.getBoundingClientRect();
      const anchorRect = anchor ? anchor.getBoundingClientRect() : frameRect;
      const header = document.querySelector('.section-header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const height = button.offsetHeight || 44;
      const anchorTop = anchorRect.top + (anchorRect.height - height) / 2;
      const maxTop = frameRect.bottom - height - 12;
      let top = Math.max(anchorTop, headerBottom + 16);
      if (top > maxTop) top = maxTop;
      button.classList.add('is-pinned');
      button.style.top = `${Math.round(top)}px`;
      button.style.right = `${Math.round(Math.max(8, window.innerWidth - frameRect.right + 8))}px`;
    }
  }

  function boot() {
    if (!window.RbProductVergleichData) return;
    document.querySelectorAll('[data-rb-product-vergleich]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      new ProductVergleich(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
